import { gql } from '@apollo/client';
import { betaTriggerFragments } from './triggers';
import { betaNodeFragments } from './nodes';

export const nodeDataFragment = gql`
  # nodes
  ${betaNodeFragments}
  # triggers
  ${betaTriggerFragments}

  fragment NodeDataFragment on NodeData {
    ## NODES ##
    ... on AddUserToListAction {
      ...AddUserToListActionFragment
    }
    ... on CallWebhookAction {
      ...CallWebhookActionFragment
    }
    ... on ChangeContactFieldAction {
      ...ChangeContactFieldActionFragment
    }
    ... on ChannelOptimizedSendAction {
      ...ChannelOptimizedFragment
    }
    ... on DelayAction {
      ...DelayActionFragment
    }
    ... on HoldUntilReplyAction {
      ...HoldUntilReplyActionFragment
    }   
    ... on FieldsMatchFilter {
      ...FieldsMatchFilterFragment
    }
    ... on RemoveUserFromListAction {
      ...RemoveUserFromListActionFragment
    }
    ... on ModifyChannelSubscriptionAction {
      ...ModifyChannelFragment
    }
    ... on ModifyMessageTypeSubscriptionAction {
      ...ModifyMessageFragment
    }
    ... on SendEmailAction {
      ...SendEmailActionFragment
    }
    ... on SendPushAction {
      ...SendPushActionFragment
    }
    ... on SendSMSAction {
      ...SendSMSActionFragment
    }
    ... on SendInAppAction {
      ...SendInAppActionFragment
    }
    ... on SendEmbeddedAction {
      ...SendEmbeddedActionFragment
    }
    ... on SendWebPushAction {
      ...SendWebPushActionFragment
    }
    ... on SendWhatsAppAction {
      ...SendWhatsAppActionFragment
    }

    ## TRIGGERS ##
    ... on FieldChangedTrigger {
      ...FieldChangedTriggerFragment
    }
    ... on ReceivedApiTriggerTrigger {
      ...ReceivedApiTriggerTriggerFragment
    }
    ... on ScheduledRecurringListTrigger {
      ...ScheduledRecurringListTriggerFragment
    }
    ... on SubscribedToListTrigger {
      ...SubscribedToListTriggerFragment
    }
    ... on TriggeredCustomEventTrigger {
      ...TriggeredCustomEventTriggerFragment
    }
  }
`;
